import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Payment from '../components/Payment/Payment'
import { fetchLabels } from '../utils/Label'
import { fetchData } from '../utils/Utils'
import { voiceStore } from '../stores/voiceStore'
import { observer } from 'mobx-react-lite'

const PaymentPage = () => {
  const [labels, setLabels] = useState('')
  const [customerInfo, setCustomerInfo] = useState(null);
  const [voiceCommand, setVoiceCommand] = useState()

  useEffect(() => {
    fetchData()
      .then(data => {
        // sessionStorage.setItem("CommunicationLanguage", JSON.stringify(data?.data?.CustomerDetails.CommunicationLanguage))
        setVoiceCommand(data?.data?.GroupDetails?.Customers[0]?.NextInstalmentDetails?.VoiceCommand2)
        voiceStore.setVoiceCommand(data?.data?.GroupDetails?.Customers[0]?.NextInstalmentDetails?.VoiceCommand2)
        setCustomerInfo(data.data);
        fetchLabels()
          .then((updatedLabels) => {
            setLabels(updatedLabels);
          })
          .catch((error) => {
            console.error("Failed to fetch labels:", error);
          });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }, []);

  useEffect(() => {
    const fetchLabelsData = async () => {
      const updatedLabels = await fetchLabels();
      setLabels(updatedLabels)
    };

    fetchLabelsData();
  }, [sessionStorage.getItem("CommunicationLanguage"), voiceStore.language]);

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <Header breadcrumbs="Customer App" customerInfo={customerInfo} labels={labels} />
        <div className="flex-grow mx-4 mb-16 overflow-auto font-gotham-rounded">
          <Payment labels={labels} voiceCommand={voiceCommand} />
        </div>
        <Footer className="fixed bottom-0 w-full bg-white" labels={labels} />
      </div>
    </>
  )
}

export default observer(PaymentPage)